import find from 'lodash/find';
import pick from 'lodash/pick';
import get from 'lodash/get';
import size from 'lodash/size';

// inefficient but it works
export const flatten = (array, result = []) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const node of array) {
    result.push(node);

    if (node.children) flatten(node.children, result);
  }

  return result;
};

export const findNode = (tree, id) => {
  if (!tree || !tree.children) return { children: [] };

  const flat = flatten(tree.children);

  return find(flat, node => node.id === id) || { children: [] };
};

export const buildPath = (children = [], id, displayKey = 'displayName') => {
  // eslint-disable-next-line no-restricted-syntax
  for (const node of children) {
    if (node.id === id) {
      return [pick(node, ['id', displayKey])];
    }

    const childNode = buildPath(node.children, id, displayKey);
    if (size(childNode)) {
      return [pick(node, ['id', displayKey])].concat(childNode);
    }
  }

  return [];
};

export const getChildren = tree => {
  return get(tree, 'children', []);
};

export const getPath = (tree, id, displayKey) => {
  const selectedId = id;
  const children = getChildren(tree);

  return buildPath(children, selectedId, displayKey);
};
